import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FilterDropdownBase } from '../FilterDropdownBase';
import { Switch } from '../Switch';
const FilterDropdownSwitch = ({ a11ySwitchText, isActive, onClick, switchTitle, ...restProps }) => (_jsx(FilterDropdownBase, { ...restProps, children: _jsxs("div", { className: "d-flex align-items-center justify-content-between py-0-5x px-2x", children: [switchTitle, _jsx(Switch, { ariaLabel: a11ySwitchText, isActive: isActive, onClick: onClick })] }) }));
export { FilterDropdownSwitch };
